import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLockBodyScroll } from '@as/cotopaxi';
import { BottomSheet, Modal, Stack, TextAlpha, useDialogContext, useIsClient, useMediaQueryMatchesOnMobile, } from '@yonderland/andes-react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { connect } from 'react-redux';
import { getSelectedColorId, makeGetProductDefaults } from '../redux/product/selectors/ProductSelector';
import { promoBasketPopupActions } from '../redux/promo-basket-popup/actions/PromoBasketPopupActions.creators';
import { makeGetPromoBasketPopupState } from '../redux/promo-basket-popup/selectors/PromoBasketPopupSelector';
import PromoBasketPopupContentContainer from './PromoBasketPopupContentContainer';
import PromoBasketPopupCTAContainer from './PromoBasketPopupCTAContainer';
const PromoBasketModalSync = ({ isOpen, onClose, children }) => {
    const { close, isOpen: dialogIsOpen, open } = useDialogContext();
    const closeRef = useRef(close);
    const openRef = useRef(open);
    const previousIsOpen = useRef(false);
    const previousDialogIsOpen = useRef(dialogIsOpen);
    closeRef.current = close;
    openRef.current = open;
    useEffect(() => {
        if (isOpen && !previousIsOpen.current)
            openRef.current();
        if (!isOpen && previousIsOpen.current)
            closeRef.current();
        previousIsOpen.current = isOpen;
    }, [isOpen]);
    useEffect(() => {
        if (previousDialogIsOpen.current && !dialogIsOpen && isOpen)
            onClose();
        previousDialogIsOpen.current = dialogIsOpen;
    }, [dialogIsOpen, isOpen, onClose]);
    return isOpen || dialogIsOpen ? _jsx(_Fragment, { children: children }) : null;
};
export const PromoBasketPopupContainer = ({ dispatchInitializeAction, closePopup, popupState, productReady, }) => {
    var _a;
    const isMobile = useMediaQueryMatchesOnMobile();
    const isClient = useIsClient();
    const [isSizeGuideOpen, setIsSizeGuideOpen] = useState(false);
    const isOpen = productReady && !popupState.collapsed;
    const title = (_a = popupState.message) !== null && _a !== void 0 ? _a : '';
    useLockBodyScroll(isOpen);
    const handleClose = useCallback(() => {
        closePopup();
    }, [closePopup]);
    useEffect(() => {
        dispatchInitializeAction();
    }, []);
    if (!isClient)
        return null;
    const content = (_jsxs(Stack, { direction: "col", gap: "6", children: [_jsx(TextAlpha, { as: "h2", variant: "headingS", children: title }), productReady && (_jsx(PromoBasketPopupContentContainer, { closePopup: handleClose, onSizeGuideOpenChange: setIsSizeGuideOpen }))] }));
    if (isMobile) {
        return createPortal(_jsx(BottomSheet, { isOpen: isOpen, onClose: handleClose, ariaLabel: title, hasCloseBtn: true, footer: isOpen ? _jsx(PromoBasketPopupCTAContainer, { closePopup: handleClose }) : null, fullHeightOnScroll: true, testId: "promo-basket-popup-bottom-sheet", children: isOpen && content }), document.body);
    }
    return (_jsx(Modal, { closedby: isSizeGuideOpen ? 'none' : 'any', hasCloseBtn: true, isOpen: isOpen, testId: "promo-basket-popup-modal", zIndex: "drawer", children: _jsx(Modal.Content, { children: _jsx(PromoBasketModalSync, { isOpen: isOpen, onClose: handleClose, children: content }) }) }));
};
const makeMapStateToProps = () => {
    const getPromoBasketPopupState = makeGetPromoBasketPopupState();
    const getProductDefaults = makeGetProductDefaults();
    const mapStateToProps = (state) => ({
        popupState: getPromoBasketPopupState(state),
        productReady: !!getProductDefaults(state).productCode && !!getSelectedColorId(state),
    });
    return mapStateToProps;
};
const mapDispatchToProps = {
    closePopup: promoBasketPopupActions.createPopupCloseAction,
    dispatchInitializeAction: promoBasketPopupActions.createInitializeAction,
};
export default connect(makeMapStateToProps, mapDispatchToProps)(PromoBasketPopupContainer);
